export enum NOTIFICATION_TYPES {
  INFO = "info",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}

export interface Notifications {
  show: boolean;
  avatarLiteralName: string;
  type: NOTIFICATION_TYPES;
  title: string;
  message: string;
  data: object;
}
